<template>
    <v-dialog :value="1" max-width="500px" persistent>
        <v-card class="pa-6" elevation="4" rounded="lg" tabindex="-1">
            <!-- Cabeçalho com título destacado -->
            <v-card-title class="d-flex justify-center align-center pb-6">
                <span class="text-h5 font-weight-bold primary--text">
                    Autenticação Segura
                </span>
            </v-card-title>

            <!-- Conteúdo centralizado -->
            <v-card-text class="pa-0">
                <v-container>
                    <v-row justify="center">
                        <!-- Ícone maior e mais impactante -->
                        <v-col cols="12" class="text-center">
                            <v-icon size="100" color="primary" class="mb-6 animate-icon">
                                mdi-lock-reset
                            </v-icon>
                        </v-col>

                        <!-- Texto descritivo mais rico -->
                        <v-col cols="12" class="text-center">
                            <p class="text-subtitle-1 grey--text text--darken-2 mb-2">
                                Insira seu código de acesso para prosseguir
                            </p>
                            <p class="text-body-2 grey--text">
                                Pressione <strong>Enter</strong> para confirmar
                            </p>
                        </v-col>

                        <!-- Campo de entrada com destaque -->
                        <v-col cols="10" class="mt-6">
                            <Input type="password" v-model="access_code" @keydown.enter="authenticate" ref="accessInput"
                                class="centered-input" autofocus />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import { mapActions, mapState } from "vuex";

    export default {
        data() {
            return {
                access_code: '',
                dialog: true,
            };
        },

        computed: {
            ...mapState("auth", ["user", "logged"]),
        },

        methods: {
            ...mapActions("auth", ["login", "getUser"]),
            ...mapActions("cashier", ["activeCashier"]),
            ...mapActions("paymentMethod", ["showPaymentMethods"]),
            ...mapActions("product", ["showFavoriteProducts"]),
            ...mapActions("customer", ["showByCard"]),

            authenticate() {
                this.login({
                    access_code: this.access_code
                }).then(() => {
                    this.getUser();
                    this.activeCashier();
                    this.showPaymentMethods();
                    this.showFavoriteProducts();
                    this.showByCard(1);
                });
            },
        },
    };
</script>
